export const resendInvoice = (orderObjectId: string) => {
	return {
		method: "POST",
		url: `${process.env.REACT_APP_ORIGIN}/invoice/order/${orderObjectId}/resendInvoice`,
	}
}
